import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { country_code_list } from './Functions';
import '../../entity-forms.css';

const CITIES = ['Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah','Fujairah','Umm Al Quwain'];
const TASK_OPTIONS = Array.from({ length: 20 }, (_, i) => i + 1);

export default function Rider() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [teams, setteams]           = useState([]);
  const [zones, setzones]           = useState([]);
  const [search, setSearch]         = useState('');

  const initForm = { user: sessionStorage.getItem('userid'), country: 'United Arab Emirates' };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');
  const [smsMsg, setSmsMsg]         = useState('');
  const [pwd, setPwd]               = useState('');
  const [pwdMsg, setPwdMsg]         = useState('');
  const smsLoading = useRef(false);

  useEffect(() => { loadList(); loadTeams(); loadZones(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);
      if (res.data.success) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadTeams = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getTeams`);
      if (res.data.data) setteams(res.data.data);
    } catch {}
  };

  const loadZones = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/driver/getZones`);
      if (res.data.data) setzones(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setPwd(''); setPwdMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setPwd(''); setPwdMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); setPwd(''); setPwdMsg(''); };

  const validate = () => {
    if (!form.name || !form.emailId || !form.phoneNumber || !form.city || !form.teamId || !form.zoneId) {
      setMsg('Please fill all required fields (*)');
      return false;
    }
    setMsg('');
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const commonFields = {
        ...form,
        userCreatedBy: sessionStorage.getItem('userid'),
        roleName: 'Driver',
        updatedBy: sessionStorage.getItem('userid'),
        supervisor_user_id: sessionStorage.getItem('userid'),
        isActive: true,
        status: 'Active',
      };
      let res;
      if (isEdit) {
        res = await axios.put(`${API_URL}shypvdriverapp/driver/updateDriver/${form.driverId}`, commonFields, {
          headers: { 'Content-Type': 'application/json' },
        });
      } else {
        res = await axios.post(`${API_URL}shypvdriverapp/driver/createDriver`, commonFields, {
          headers: { 'Content-Type': 'application/json' },
        });
      }
      if (res.data.success) {
        // If a password was typed on the edit form, set it as part of the update.
        if (isEdit && pwd && pwd.trim()) {
          try {
            await axios.post(
              `${API_URL}shypvdriverapp/driver/setPassword`,
              null,
              { params: { driverId: form.driverId, password: pwd.trim(), sendSms: true } }
            );
          } catch { /* best-effort — the profile itself already saved */ }
        }
        closeDrawer(); loadList();
      }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} rider(s)?`)) return;
    try {
      const res = await axios.delete(`${API_URL}shypvdriverapp/driver/deleteDriver`, {
        headers: { 'Content-Type': 'application/json' },
        data: { driverIds: selectedIds },
      });
      if (res.data.success) { setSelectedIds([]); loadList(); }
      else setErrMsg('Delete failed');
    } catch { setErrMsg('Error deleting rider'); }
  };

  const resendSMS = async () => {
    if (!selectedRow || smsLoading.current) return;
    smsLoading.current = true;
    setSmsMsg('Sending…');
    try {
      const res = await axios.post(
        `${API_URL}shypvdriverapp/driver/resendSMS`,
        { driverId: selectedRow.driverId },
        { headers: { 'Content-Type': 'application/json' } }
      );
      setSmsMsg(res.data.success ? 'SMS sent successfully' : 'SMS send failed');
    } catch { setSmsMsg('Error sending SMS'); }
    smsLoading.current = false;
    setTimeout(() => setSmsMsg(''), 4000);
  };

  // Admin-set password: type one or Generate, then set it + SMS the driver.
  const genPassword = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let s = '';
    for (let i = 0; i < 8; i++) s += chars[Math.floor(Math.random() * chars.length)];
    return s;
  };

  const setPasswordAction = async () => {
    const driverId = form.driverId;
    if (!driverId) return;
    setPwdMsg('Sending…');
    try {
      const res = await axios.post(
        `${API_URL}shypvdriverapp/driver/setPassword`,
        null,
        { params: { driverId, password: pwd || '', sendSms: true } }
      );
      if (res.data && res.data.success) {
        setPwd(res.data.password || pwd);
        setPwdMsg(`Password set${res.data.smsSent ? ' & SMS sent' : ''}: ${res.data.password}`);
      } else {
        setPwdMsg((res.data && res.data.message) || 'Failed to set password');
      }
    } catch {
      setPwdMsg('Error setting password');
    }
    setTimeout(() => setPwdMsg(''), 10000);
  };

  // View the driver's current password (only works for ones set via setPassword).
  const viewPassword = async () => {
    if (!form.driverId) return;
    setPwdMsg('Loading…');
    try {
      const res = await axios.get(
        `${API_URL}shypvdriverapp/driver/getPassword`,
        { params: { driverId: form.driverId } }
      );
      if (res.data && res.data.password) {
        setPwd(res.data.password);
        setPwdMsg('Current password loaded into the box above.');
      } else {
        setPwdMsg('No stored password — set one below first.');
      }
    } catch {
      setPwdMsg('Could not load password');
    }
    setTimeout(() => setPwdMsg(''), 8000);
  };

  const toggleSelect = (id, row) => {
    if (selectedIds.includes(id)) {
      const next = selectedIds.filter(x => x !== id);
      setSelectedIds(next);
      if (!next.length) { setSelectedRow(null); setForm(initForm); }
    } else {
      setSelectedRow(row);
      setSelectedIds(prev => [...prev, id]);
    }
  };

  const filtered = data.filter(r =>
    !search ||
    r.name?.toLowerCase().includes(search.toLowerCase()) ||
    r.emailId?.toLowerCase().includes(search.toLowerCase()) ||
    r.phoneNumber?.includes(search)
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search riders…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Rider</button>
        {selectedIds.length === 1 && selectedRow && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(selectedRow)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length === 1 && selectedRow && (
          <button className="em-btn" style={{ background:'#0ea5e9', color:'#fff', border:'none' }}
            onClick={resendSMS} disabled={!!smsMsg && smsMsg === 'Sending…'}>
            <i className={`fa ${smsMsg === 'Sending…' ? 'fa-spinner fa-spin' : 'fa-mobile'}`} /> Resend SMS
          </button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="riders.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {smsMsg && <span style={{ fontSize:12, color:'#0ea5e9', fontWeight:600 }}>{smsMsg}</span>}
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.driverId) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['ID','Name','Phone','Email','Team','Zone','City','Status','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading riders…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No riders found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.driverId);
              return (
                <tr key={row.driverId} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.driverId, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.driverId}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.name}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.phoneNumber}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.emailId}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.teamId}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.zoneId}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.city}</td>
                  <td className="em-td">
                    <span className={`em-badge ${row.isActive||row.status==='Active'?'em-badge-green':'em-badge-red'}`}>
                      {row.isActive||row.status==='Active'?'Active':'Inactive'}
                    </span>
                  </td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} rider{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && ReactDOM.createPortal(
        <div className="em-modal-wrap" onClick={e => { if (e.target === e.currentTarget) closeDrawer(); }}>
          <div className="em-modal">
            <div className="em-modal-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-user" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Rider' : 'Add New Rider'}</p>
                    <p className="em-drawer-sub">{isEdit ? `ID: ${form.driverId}` : 'Fill in the rider details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-modal-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Full Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.name||''} placeholder="e.g. Ahmed Ali"
                    onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Phone<span className="em-req">*</span></label>
                  <input className="em-field" value={form.phoneNumber||''} placeholder="+971 50 000 0000"
                    onChange={e => setForm(p => ({ ...p, phoneNumber: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Email<span className="em-req">*</span></label>
                  <input className="em-field" type="email" value={form.emailId||''} placeholder="rider@example.com"
                    onChange={e => setForm(p => ({ ...p, emailId: e.target.value }))} />
                </div>
                {!isEdit && (
                  <div className="em-form-row">
                    <label className="em-label">Password<span className="em-req">*</span></label>
                    <input className="em-field" type="password" value={form.password||''} placeholder="Set password"
                      onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />
                  </div>
                )}
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Team<span className="em-req">*</span></label>
                  <select className="em-field" value={form.teamId||''} onChange={e => setForm(p => ({ ...p, teamId: e.target.value }))}>
                    <option value="">— Select team —</option>
                    {teams.map(t => <option key={t.teamId} value={t.teamId}>{t.teamName}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Zone<span className="em-req">*</span></label>
                  <select className="em-field" value={form.zoneId||''} onChange={e => setForm(p => ({ ...p, zoneId: e.target.value }))}>
                    <option value="">— Select zone —</option>
                    {zones.map(z => <option key={z.zone_id} value={z.zone_id}>{z.short_code} - {z.district}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">City<span className="em-req">*</span></label>
                  <select className="em-field" value={form.city||''} onChange={e => setForm(p => ({ ...p, city: e.target.value }))}>
                    <option value="">— Select city —</option>
                    {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Country</label>
                  <select className="em-field" value={form.country||'United Arab Emirates'}
                    onChange={e => setForm(p => ({ ...p, country: e.target.value }))}>
                    {Object.entries(country_code_list()).map(([code, name]) => <option key={code} value={name}>{name}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Date of Birth</label>
                  <input className="em-field" type="date" value={form.dob||''}
                    onChange={e => setForm(p => ({ ...p, dob: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Joining Date</label>
                  <input className="em-field" type="date" value={form.joiningDate||''}
                    onChange={e => setForm(p => ({ ...p, joiningDate: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row">
                <label className="em-label">Address</label>
                <input className="em-field" value={form.address||''} placeholder="Street address"
                  onChange={e => setForm(p => ({ ...p, address: e.target.value }))} />
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Min Tasks</label>
                  <select className="em-field" value={form.minTask||''} onChange={e => setForm(p => ({ ...p, minTask: e.target.value }))}>
                    <option value="">Select</option>
                    {TASK_OPTIONS.map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Max Tasks</label>
                  <select className="em-field" value={form.maxTask||''} onChange={e => setForm(p => ({ ...p, maxTask: e.target.value }))}>
                    <option value="">Select</option>
                    {TASK_OPTIONS.map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-row" style={{ maxWidth:240 }}>
                <label className="em-label">Availability</label>
                <select className="em-field" value={form.availability||'Available'} onChange={e => setForm(p => ({ ...p, availability: e.target.value }))}>
                  <option value="Available">Available</option>
                  <option value="Unavailable">Unavailable</option>
                  <option value="On Leave">On Leave</option>
                </select>
              </div>
              {isEdit && (
                <div className="em-form-row" style={{ maxWidth: 520 }}>
                  <label className="em-label">Set Login Password</label>
                  <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                    <input
                      className="em-field"
                      type="text"
                      placeholder="Type a password, or click Generate"
                      value={pwd}
                      onChange={e => setPwd(e.target.value)}
                      style={{ flex:'1 1 200px' }}
                    />
                    <button type="button" className="em-btn em-btn-ghost"
                      onClick={viewPassword}>
                      <i className="fa fa-eye" style={{ marginRight:6 }} />Show
                    </button>
                    <button type="button" className="em-btn em-btn-ghost"
                      onClick={() => setPwd(genPassword())}>
                      <i className="fa fa-random" style={{ marginRight:6 }} />Generate
                    </button>
                    <button type="button" className="em-btn em-btn-primary"
                      onClick={setPasswordAction} disabled={pwdMsg === 'Sending…'}>
                      <i className="fa fa-key" style={{ marginRight:6 }} />Set &amp; Send SMS
                    </button>
                  </div>
                  <p className="em-label" style={{ fontWeight:400, opacity:0.7, marginTop:6 }}>
                    Leave blank and click Set to auto-generate. The password is texted to the driver.
                  </p>
                  {pwdMsg && <p className="em-msg-error" style={{ marginTop:4 }}>{pwdMsg}</p>}
                </div>
              )}
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-modal-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Rider':'Save Rider'}
              </button>
            </div>
          </div>
        </div>
      , document.body)}
    </div>
  );
}
